import { alpha, Theme } from "@mui/material";

// TODO: This component needs a complete rework once legacy support is no longer required

export type Statuses =
  | "success"
  | "danger"
  | "warning"
  | "guidance"
  | "informational"
  | "ice"
  | "standard"
  | "default";

export interface StatusColors {
  backgroundColor?: string;
  borderColor?: string;
  hoverBackgroundColor?: string;
  hoverColor?: string;
  opacity?: string;
  borderRadius?: string;
  background?: string;
  color?: string;
  fontWeight?: string;
  height?: string;
  padding?: string;
  fontSize?: string;
}

export function setStatusStyle(
  color:
    | "success"
    | "danger"
    | "warning"
    | "guidance"
    | "informational"
    | "ice"
    | "standard"
    | "default",
  returnColor: StatusColors,
  theme: Theme
) {
  switch (color) {
    case "informational": {
      returnColor.backgroundColor = theme.palette.secondary.main + "0D";
      returnColor.hoverBackgroundColor = theme.palette.secondary.main + "80";
      returnColor.borderColor = "secondary.main";
      break;
    }
    case "guidance": {
      returnColor.backgroundColor = "info.light";
      returnColor.hoverBackgroundColor = theme.palette.info.dark + "80";
      returnColor.borderColor = "info.dark"; //is purple
      break;
    }
    case "success": {
      returnColor.backgroundColor = theme.palette.success.light + "1F";
      returnColor.hoverBackgroundColor = theme.palette.success.light + "80";
      returnColor.borderColor = "success.light";
      break;
    }
    case "warning": {
      returnColor.backgroundColor = theme.palette.warning.main + "0D";
      returnColor.hoverBackgroundColor = theme.palette.warning.main + "80";
      returnColor.borderColor = "warning.main";
      break;
    }
    case "danger": {
      returnColor.backgroundColor = theme.palette.error.main + "0D";
      returnColor.hoverBackgroundColor = theme.palette.error.main + "80";
      returnColor.borderColor = "error.main";
      break;
    }
    case "ice": {
      returnColor.backgroundColor = theme.palette.secondary.main + "0D";
      returnColor.hoverBackgroundColor = theme.palette.secondary.main + "80";
      returnColor.borderColor = "secondary.main";
      break;
    }
    case "standard": {
      returnColor.background = `linear-gradient(0deg, ${alpha(
        theme.palette.secondary.main,
        0.56
      )} 0%, ${alpha(theme.palette.secondary.main, 0.56)} 100%, ${
        theme.palette.background.default
      })`;
      returnColor.borderColor = "transparent";
      returnColor.color = theme.palette.secondary.contrastText;
      returnColor.borderRadius = "8px";
      returnColor.fontWeight = "400";
      returnColor.height = "32px !important";
      returnColor.padding = "0px 5px";
      returnColor.fontSize = "14px";
      break;
    }
    case "default": {
      returnColor.backgroundColor = theme.palette.background.default;
      returnColor.hoverBackgroundColor = theme.palette.grey[200];
      returnColor.borderColor = "text.primary";
    }
  }
  return returnColor;
}
